

export const AI_PANEL_WIDTH_KEY = 'aiPanelWidth';

export const AI_PANEL_INTERACTIVE_KEY = 'aiPanelInteractiveMode';

export const AI_PANEL_AUTORUN_KEY = 'aiPanelAutoRunMode';

/** Quiet period after a turn before the thread is written. Long enough that a
 *  burst of state settles, short enough to survive a quick close. */
export const CONVERSATION_SAVE_DEBOUNCE_MS = 400;

// Sentinel result marking a tool call that is waiting for the user's Confirm/Cancel
// (Auto-run off). Rendered as an approval card by ToolCallCard.
export const CONFIRM_PENDING = { __awaitingConfirm: true };

export const AI_PANEL_MIN_WIDTH = 280;

export const AI_PANEL_MAX_WIDTH = 720;

export const AI_PANEL_DEFAULT_WIDTH = 380;

export const CHAT_INPUT_MAX_HEIGHT = 132;

export const TOOL_BODY_MAX_CHARS = 6000;

// Soft threshold for the context meter: past this the conversation is large
// enough that cost/latency climb and it's worth suggesting a fresh session.
export const CONTEXT_WARN_TOKENS = 120_000;
